export const GUIDE_INSURANCE_COST = 30;
